import React from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade';

interface IProps {
  jpnLabel: string;
  engLabel: string;
}

export const TwoTitle = (props: IProps) => {
  return (
    <Fade left cascade duration={500} distance="40px">
      <div className="twoTitle">
        <h2 translate='no'>{props.jpnLabel}</h2>
        <h3 translate='no'>{props.engLabel}</h3>
      </div>
    </Fade>
  )
}